import BaseService from '_services/rest/base';

class SettingsService extends BaseService {
  constructor() {
    super();
  }

  getUrl() {
    return `${super.getUrl()}api/settings`;
  }

  getSettings() {
    return this.request(`${this.getUrl()}/all`)
      .then(response => response.data)
      .catch(err => {
        throw err;
      });
  }

  prepareOptions(settings, type = 'company') {
    const options = [];
    Object.keys(settings).map(key => (
      options.push({
        option: `${type}_${key}`,
        value: settings[key] || '',
      })
    ));
    return { ...options };
  }

  upload(file) {
    const formData = new FormData();
    formData.append('file', file);
    return this.request(`${super.getUrl()}api/file`, formData, 'POST')
      .then(response => response.data)
      .catch(err => {
        throw err;
      });
  }

  saveOptions(settings, type) {
    const options = this.prepareOptions(settings, type);
    return this.request(`${this.getUrl()}`, { options }, 'PUT')
      .catch(err => {
        throw err;
      });
  }
}

export default new SettingsService();
